export default {

  reorderDynamicFormScreens({ commit }, screens) {
    commit('reorderFormScreens', screens);
    commit('setFormScreens');
  },

  removeDynamicFormScreen({ state, commit, dispatch }, number) {
    const screenToRemove = state.screens.find((screen) => screen.number === number);
    commit('deleteFormScreen', screenToRemove);

    if (screenToRemove.questionVuexId) {
      const questionToRemove = state.form.questions.find((question) => question.vuexId === screenToRemove.questionVuexId);
      dispatch('removeFormQuestion', questionToRemove);
    }

    if (state.currentScreen > 1) {
      commit('decrementCurrentFormScreen');
    }
  },

  removeFormQuestion({ state, commit }, questionToRemove) {
    let updatedFormQuestionList = null;

    if (state.form.type === 'static') {
      updatedFormQuestionList = state.form.questions.filter((question) => question.index !== questionToRemove.index);
    } else {
      updatedFormQuestionList = state.form.questions.filter((question) => question.vuexId !== questionToRemove.vuexId);
    }

    commit('setFormQuestions', updatedFormQuestionList);

    // Check for any conditional logic relationships to the removed question in the remaining form questions
    const removeConditionalLogicLinksToRemovedQuestion = () => {
      const linkedQuestionIndex = updatedFormQuestionList.findIndex((question) => {
        if (question.conditional_logic) {
          return questionToRemove.html_form_input_id === question.conditional_logic.related_to_question_uuid;
        }
        return false;
      });

      // if findIndex found the question...
      if (linkedQuestionIndex !== -1) {
        updatedFormQuestionList[linkedQuestionIndex].conditional_logic = null;
        commit('setFormQuestions', updatedFormQuestionList);

        removeConditionalLogicLinksToRemovedQuestion();
      }
    };

    removeConditionalLogicLinksToRemovedQuestion();
    commit('resetSelectedQuestion');

    if (state.form.type === 'dynamic') {
      commit('removeQuestionFromScreen', questionToRemove);
    }
  },
};
